/**
 * Route guard for everything under /app. A guest is sent to the sign-in gate
 * carrying where they were going (`?next=`), the same way the prototype's
 * "guard 1" did. While the session bootstraps nothing is decided yet, so a
 * refresh on a deep link never flashes the sign-in page.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../app/routes';
import { useAuth } from './AuthProvider';
import { FullPageLoader } from '../components/FullPageLoader';

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'loading') return <FullPageLoader label="Loading your workspace…" />;
  if (status === 'signed-out') {
    const next = location.pathname + location.search;
    return <Navigate to={ROUTES.auth + '?next=' + encodeURIComponent(next)} replace />;
  }
  if (status === 'error') return <FullPageLoader label="ClimbJobs is not reachable right now." sub="Check your connection and refresh." error />;
  return <>{children}</>;
}
